import { Component, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';

@Component({
	selector: 'copo-user-self-card-privacy-settings',
	templateUrl: './user-self-card-privacy-settings.component.html',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	styleUrl: './user-self-card-privacy-settings.component.css',
	imports: [TranslateModule, LoadingSpinnerComponent]
})

export class UserCardPrivacySettingsComponent {}
